import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgNieuweWoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="m18 8 10 8v16H8V16z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M16 22h-6v10h6zM28 6.53l-2.97 6.03-6.65.97 4.81 4.69-1.14 6.62L28 21.71l5.95 3.13-1.14-6.62 4.82-4.69-6.66-.97z"
    />
    <path
      fill="#00215C"
      fillRule="evenodd"
      d="m19.55 13.772 3.107 3.034-1.012 5.881 5.285-2.771 3.161 1.65-.463.887-2.698-1.409-6.615 3.47 1.268-7.36-2.732-2.666z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgNieuweWoning);

export default ForwardRef;
